import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Generate or retrieve session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('ct_session_id');
  if (!sessionId) {
    sessionId = 'sess_' + Math.random().toString(36).substr(2, 9) + Date.now().toString(36);
    sessionStorage.setItem('ct_session_id', sessionId);
  }
  return sessionId;
};

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Don't track admin pages
    if (location.pathname.startsWith('/admin')) {
      return;
    }

    // Track page view
    const trackPageView = async () => {
      try {
        await fetch(`${API_URL}/api/track/pageview`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            page_path: location.pathname,
            page_title: document.title,
            referrer: document.referrer || null,
            user_agent: navigator.userAgent,
            session_id: getSessionId(),
          }),
        });
      } catch (err) {
        // Silently fail - don't break the app for tracking
        console.debug('Tracking failed:', err);
      }
    };

    // Delay slightly to ensure page has rendered
    const timer = setTimeout(trackPageView, 100);
    return () => clearTimeout(timer);
  }, [location.pathname]);
};

export default usePageTracking;
